import { Component, Input, ViewChild } from '@angular/core';
import { DxFormComponent } from 'devextreme-angular/ui/form';
import { DEFAULT_REGISTRATION_FIELDS } from 'src/app/config/registration-field-config/registration-field-config.defaults';
import { REGISTRATION_FIELD_KEYS } from 'src/app/config/registration-field-config/registration-field.keys';
import { REGISTRATION_FIELD_LABEL_KEYS, REGISTRATION_FIELD_REQUIRED_MESSAGE_KEYS } from 'src/app/config/registration-field-config/registration-field.text-maps';
import { RegistrationFieldConfigModel } from 'src/app/models/registration-field-configs/registration-field-config.model';

@Component({
  selector: 'app-registration-field-config',
  standalone: false,
  templateUrl: './registration-field-config.component.html',
  styleUrl: './registration-field-config.component.scss',
})
export class RegistrationFieldConfigComponent {
  @Input() 
  formLabel = '';

  @Input()
  fields: RegistrationFieldConfigModel[] = [];

  @ViewChild('previewForm', { static: false }) 
  previewForm!: DxFormComponent;
  
  readonly defaultFields = DEFAULT_REGISTRATION_FIELDS;
  readonly emailKey = REGISTRATION_FIELD_KEYS.email;

  isTermsAccepted: boolean = false;

  get previewFields(): RegistrationFieldConfigModel[] {
    return this.fields
      .filter(f => f.visible)
      .sort((a, b) => a.order - b.order);
  }

  public getLabelKey(key: string): string {
    return REGISTRATION_FIELD_LABEL_KEYS[key] ?? key;
  }

  public getRequiredMessageKey(key: string): string {
    return REGISTRATION_FIELD_REQUIRED_MESSAGE_KEYS[key] ?? key;
  }

  onSendPreview() {
    const result = this.previewForm.instance.validate();

    if (!result.isValid) {
      return;
    }
  }

  onRowPrepared(e: any) {
    if (e.rowType !== 'data') return;

    if (e.data?.isLocked) {
      e.rowElement.classList.add('locked-row');
    }
  }

  onReorder = (e: any) => {
    const visibleRows = e.component.getVisibleRows();

    const draggedItem = e.itemData;
    const toIndex = e.toIndex;

    const fromIndex = this.fields.findIndex(
      x => x.key === draggedItem.key
    );

    const targetKey = visibleRows[toIndex].data.key;

    const newIndex = this.fields.findIndex(
      x => x.key === targetKey
    );

    this.fields.splice(fromIndex, 1);
    this.fields.splice(newIndex, 0, draggedItem);

    this.recalculateOrder();
  };

  onVisibleChange(field: RegistrationFieldConfigModel): void {
    if (!field.visible) {
      field.required = false;
    }
  }

  onRequiredChange(field: RegistrationFieldConfigModel): void {
    if (!field.visible) {
      field.required = false;
    }
  }

  private recalculateOrder(): void {
    this.fields = this.fields.map((f, index) => ({
      ...f,
      order: index + 1
    }));
  }

  private sortFields(): void {
    this.fields.sort((a, b) => a.order - b.order);
  }

  reset(): void {
    this.fields = structuredClone(this.defaultFields);
    this.sortFields();
  }  
}
